/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const contactFieldSignalResponseDtoSchema = z.object({
    "id": z.string(),
"tenantId": z.string(),
"type": z.enum(["email", "phone", "links", "full_name", "first_name", "last_name", "preferred_name", "street_address", "city", "state", "postal_code", "job_title", "company_name", "timezone", "seniority", "department", "role_type", "company_domain", "company_size", "company_industry", "country"]),
"contactId": z.nullable(z.string()),
"extractedPersonId": z.string(),
"interactionId": z.string(),
"value": z.string(),
"occurredAt": z.iso.datetime(),
"confidence": z.number().describe("Confidence score between 0 and 1.0"),
"source": z.enum(["email:signature", "email:body", "email:headers", "email:subject", "email:quoted_text", "email:forward-header", "memo:body", "enrichment:social_profile", "user:input", "user:reviewed"]),
"signalQuality": z.enum(["direct", "inferred", "user_provided"]),
"quotedText": z.string(),
"status": z.enum(["unprocessed", "processed", "active", "pending", "superseded", "rejected", "duplicated"]),
"channel": z.optional(z.object({
    "type": z.string(),
"referenceId": z.string()
    })),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })